/* eslint-disable */
import { camelCase, snakeCase } from 'lodash';

export const camelCaseKeys = (params: any) =>
  Object.keys(params).reduce((accumulator: any, loopParam: string) => {
    accumulator[camelCase(loopParam)] = params[loopParam];
    return accumulator;
  }, {});

export const snakeCaseKeys = (params: any) =>
  Object.keys(params).reduce((accumulator: any, loopParam: string) => {
    accumulator[snakeCase(loopParam)] = params[loopParam];
    return accumulator;
  }, {});
